export default "__VITE_ASSET__8074f135__"